// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + "." + {"5865":"42c313e123a54680","7538":"97f5b9bd73df441a","9434":"8a56e9ee27731f64","9983":"32b6bc3d0c9fcfef"}[chunkId] + ".js";
};